import breadCrumbSchema from '@seo/schemas/breadcrumb';
import courseSkeletonSchema from '../schemas/course';

const courseSchema = (goal = {}, description, course = {}) => {
  const graph = [];

  if (course.name) {
    graph.push(courseSkeletonSchema(course));
  }

  const breads = [
    {
      url: 'https://unacademy.com/explore',
      name: 'Explore'
    }
  ];
  if (goal.permalink && goal.name)
    breads.push({
      url: goal.permalink,
      name: goal.name
    });
  if (course.permalink && course.name)
    breads.push({
      url: course.permalink,
      name: course.name
    });
  graph.push(breadCrumbSchema(breads));
  const schema = {
    '@context': 'https://schema.org/',
    '@graph': graph
  };
  return schema;
};

export default courseSchema;
